import { Box, Button, HStack, Text } from '@chakra-ui/react'
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { type ReactElement } from 'react'

import { navHeight } from '@/components/Layout/Navbar/styled'
import ShwLink from '@/components/ShwLink'

export default React.forwardRef(
  (
    {
      active,
      label,
      href = null,
      showDropdownIcon = false,
      isClickable = false,
    }: {
      active: boolean
      label: string
      href?: string | null
      showDropdownIcon?: boolean
      isClickable?: boolean
    },
    ref: React.ForwardedRef<HTMLButtonElement | null>
  ): ReactElement => {
    const button = (
      <Button
        className="group"
        cursor={isClickable ? 'pointer' : 'default'}
        role="group"
        variant="ghost"
        position="relative"
        display="flex"
        height={navHeight}
        transition="none"
        justifyContent="center"
        alignItems="center"
        mx={{ lg: '16px', xl: '20px' }}
        borderRadius={0}
        textDecoration="none"
        ref={ref}
      >
        <HStack gap="12px">
          <Text
            color={active ? 'primary.fg' : 'fg.muted'}
            _groupHover={{ color: isClickable ? 'primary.emphasized' : undefined }}
          >
            {label}
          </Text>
          {showDropdownIcon ? (
            <Box display={{ base: 'none', md: 'inline-block' }}>
              <Box
                w={5}
                h={5}
                pt="4px"
                fontSize="12px"
                color={active ? 'primary.fg' : 'fg.muted'}
                _groupHover={{ color: 'primary.emphasized' }}
              >
                <FontAwesomeIcon icon={faChevronDown} />
              </Box>
            </Box>
          ) : null}
        </HStack>
      </Button>
    )
    if (href === null) {
      return button
    }
    return <ShwLink href={href}>{button}</ShwLink>
  }
)
